import { render, staticRenderFns } from "./RegisterPrinter.vue?vue&type=template&id=aa8008d8&scoped=true&"
import script from "./RegisterPrinter.vue?vue&type=script&lang=js&"
export * from "./RegisterPrinter.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPrinter.vue?vue&type=style&index=0&id=aa8008d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8008d8",
  null
  
)

export default component.exports